import { EMPTY_LIST } from '../../../../constants/common'

export const QA_NAME_EDIT_MANAGERS_MODAL = 'editManagers'

export const BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER =
  'responsible_users'

export const BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS =
  'perform_for_buildings'

export const EDIT_MANAGERS_FORM_INITIAL_VALUES = {
  [BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER]: EMPTY_LIST,
  [BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS]: false,
}
